module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide-list"
  }, [(_vm.guideList.length > 0) ? _c('dl', _vm._l((_vm.guideList), function(d_item, d_index) {
    return _c('dd', [_c('p', [_vm._v(_vm._s(d_item.title))]), _vm._v(" "), _vm._l((d_item.itemList), function(t_item, t_index) {
      return _c('dt', [_c('router-link', {
        attrs: {
          "to": '/' + _vm.lan + '/detail/' + d_item.groupId + '/' + t_item.id
        }
      }, [_vm._v(_vm._s(t_item.title))])], 1)
    })], 2)
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e66dd3b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/GuideList.vue
// module id = 730
// module chunks = 4